import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

const Card = ({
  variant = 'default',
  hoverable = false,
  sx,
  children,
  ...rest
}) => {
  const theme = useTheme();
  const v2 = theme.palette.v2;

  const baseStyles = {
    default: {
      backgroundColor: '#FFFFFF',
      border: `1px solid ${v2.neutral[200]}`,
      boxShadow: v2.shadows.xs
    },
    elevated: {
      backgroundColor: '#FFFFFF',
      border: `1px solid ${v2.neutral[100]}`,
      boxShadow: v2.shadows.md
    },
    dark: {
      backgroundColor: v2.surface.glass,
      border: `1px solid ${v2.surface.glassBorder}`,
      color: '#FFFFFF',
      backdropFilter: 'blur(20px)'
    }
  };

  return (
    <Box
      sx={{
        borderRadius: 2.5,
        p: { xs: 3, md: 4 },
        ...baseStyles[variant],
        ...(hoverable && {
          transition: 'transform 200ms ease, box-shadow 200ms ease',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: v2.shadows.lg
          }
        }),
        ...sx
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default Card;
